import axios from '@/lib/axios'
import { buildAdminRequestConfig, type OrganizationId } from '@/lib/organization-scoping'
import type { QueryFunctionContext } from '@tanstack/react-query'
import type {
  GoogleAnalyticsIntegration,
  GoogleAnalyticsIntegrationInput,
} from './google-analytics.types'

export interface GoogleAnalyticsOrganizationScope {
  organizationId: OrganizationId
}

/** Query functions read only the key. */
type GoogleAnalyticsQueryContext<TKey> = Pick<QueryFunctionContext<[TKey]>, 'queryKey'>

export function getGoogleAnalyticsIntegration({
  queryKey: [{ organizationId }],
}: GoogleAnalyticsQueryContext<GoogleAnalyticsOrganizationScope>) {
  return axios.get<GoogleAnalyticsIntegration>(
    '/google-analytics/integration',
    buildAdminRequestConfig({ organizationId })
  )
}

export function updateGoogleAnalyticsIntegration({
  organizationId,
  measurement_id,
}: GoogleAnalyticsIntegrationInput & GoogleAnalyticsOrganizationScope) {
  return axios.put<GoogleAnalyticsIntegration>(
    '/google-analytics/integration',
    { measurement_id },
    buildAdminRequestConfig({ organizationId })
  )
}

/** Disconnects the florist's property and resolves to the disconnected integration. */
export function removeGoogleAnalyticsIntegration({
  organizationId,
}: GoogleAnalyticsOrganizationScope) {
  return axios.delete<GoogleAnalyticsIntegration>(
    '/google-analytics/integration',
    buildAdminRequestConfig({ organizationId })
  )
}
